module.exports = __webpack_public_path__ + "static/media/aracaju-se.183eac13.jpg";